import type { ReactNode } from 'react';

export const symbol_mobile_question: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-40q-24.75 0-42.37-17.63Q200-75.25 200-100v-760q0-24 18-42t42-18h438q24.75 0 42.38 17.62Q758-884.75 758-860v150q18 3 30 16.95 12 13.96 12 31.63V-587q0 19-12 33t-30 17v437q0 24.75-17.62 42.37Q722.75-40 698-40H260Zm0-60h438v-760H260v760Zm0 0v-760 760Zm245.5-188.5Q516-299 516-314t-10.5-25.5Q495-350 480-350t-25.5 10.5Q444-329 444-314t10.5 25.5Q465-278 480-278t25.5-10.5ZM379-595q10.03 5 20.51 2.5Q410-595 415-605q11-17 28-28t37-11q27 0 47 17.5t20 43.5q0 24-14.5 42.5T498-508q-20 13-31 33t-11 42.64q0 10.87 6.5 18.11Q469-407 480-407t18-6.5q7-6.5 8-17.5 1-15 9.5-27.5T536-480q26-19 43.5-45t17.5-58q0-49-33-79.5T480-693q-35 0-64.5 19T369-624q-5 8-1.5 16.5T379-595Z"
		/>
	</svg>
);
